let api_HXJ,
	api_WK,
	EQPadmin_WS;

switch (process.env.NODE_ENV) {
	case 'development':
		api_HXJ = 'http://192.168.1.155:82/';
		api_WK = 'http://192.168.1.74:8666/';
    // api_WK = "http://129.211.131.24:8080/";
		EQPadmin_WS = 'ws://192.168.1.74:9968';
		break;
	case 'production':
		api_HXJ = '/';
		api_WK = '/';
		EQPadmin_WS = 'ws://129.211.131.24:9968';
		break;
};

/* ↓ 胡夏君本地接口 */
// const normalUrl = 'http://192.168.1.155:82/Index/'
// const normalSrc = 'http://192.168.1.155:82/'

/* ↓ 胡夏君在线接口 */
// const normalUrl = '/Index/';
// const normalSrc = '/';

// const normalUrl = 'http://129.211.131.24:8080/Index/'  // 在线版 完整地址
// const normalSrc = 'http://129.211.131.24:8080/'

/* ↓ 王魁本地接口 */
// const url2 = 'http://192.168.1.74:8666/public/index.php/'

/* ↓ 王魁在线接口 */
// const url2 = '/';

const baseUrl_HXJ = process.env.API_ROOT_HXJ + 'Index/'; // 胡夏君接口
const baseUrl_WK = process.env.API_ROOT_WK;              // 王魁接口


const api = {
	apiHXJ: api_HXJ,
  normalSrc: process.env.API_ROOT_HXJ,
  //↓登录
  logIn: baseUrl_HXJ + 'Publics/signin',
  //↓登出
  logOut: baseUrl_HXJ + 'Publics/signout',
  // //↓获取侧边目录树
  // asideTree: baseUrl_HXJ + 'Publics/signout',
  //↓修改密码
  changePW: baseUrl_HXJ + 'User/setUserPassword',
  //↓获取所属单位、角色、等
  relativeJsonGet: baseUrl_HXJ + 'Business/getComboboxJson',
  //↓客户管理
  CustomerAdmin:{
    // auth: baseUrl_HXJ + 'xxxxxxxxxx',  // 获取当前用户增删改权限
    get: baseUrl_HXJ + 'Business/getCompanyList',  // 获取表格数据
    edit: baseUrl_HXJ + 'Business/ajaxSaveData',  // 新增、修改
    // del: baseUrl_HXJ + 'User/ajaxDelCompanyData',   // 删除
    del: baseUrl_HXJ + 'Business/ajaxDelCompanyData',   // 删除
    resetPW: baseUrl_HXJ + 'Business/resetUserPassword',  // 重置密码
    regenerateData: baseUrl_HXJ + 'Business/ajaxCreateSnapData',  // 重新生成数据
	},
	//↓反馈问题管理
	FeedbackQuestionsAdmin:{
		gridGet: baseUrl_HXJ + 'Replies/getFeedbackList',	// 获取问题反馈列表数据
		gridEdit: baseUrl_HXJ + 'Replies/ajaxHandleFeedbackData',	// 处理反馈问题
		gridDel: baseUrl_HXJ + 'Replies/ajaxDelFeedbackData',
	},
	//↓数据库管理
	DataBaseAdmin:{
		// 备份表格管理
		BackupTable:{
			backupAll: baseUrl_HXJ + 'Database/export',
			gridGet: baseUrl_HXJ + 'Database/getRestoreDataList',
			toOrigin: baseUrl_HXJ + 'Database/import',
			gridDel: baseUrl_HXJ + 'Database/delete',
		}
	}
};
/*---------------- ↓ 业务问答平台 ----------------*/
api.BusinessQA = {
  // ↓ 问答库
  QABase:{
    treeGet: baseUrl_HXJ + 'Replies/getqTypeTree',  // 左侧分类树
    QAget: baseUrl_HXJ + 'Replies/getRepliesList',  // 获取问答列表数据
    QAdel: baseUrl_HXJ + 'Replies/ajaxDelRepliesData',  // 删除问答列表数据
    QAedit: baseUrl_HXJ + 'Replies/ajaxRepliesSaveData',  // 添加、修改 单个问答
    QAUpload: baseUrl_HXJ + 'Upload/upImage',  // 上传多媒体答案
    uploadExcel: baseUrl_HXJ + 'Upload/uploadFile',  // 上传Excel
    QTypeEdit: baseUrl_HXJ + 'Replies/ajaxSaveQTypeData',  // 添加、修改 分类树
    QTypeDel: baseUrl_HXJ + 'Replies/ajaxDelQTypeData',  // 删除 分类树
		getBlurData: baseUrl_HXJ + 'Admin/getMatchValueData', // 获取匹配度
		setBlurData: baseUrl_HXJ + 'Admin/ajaxSaveMatchValueData', // 设置匹配度
	},
  // ↓ 专属词库
  OwnWordsBase:{
    gridGet: baseUrl_HXJ + 'Replies/getSynonymList',  // 获取专属词
    gridDel: baseUrl_HXJ + 'Replies/ajaxDelData',  // 删除专属词
    gridEdit: baseUrl_HXJ + 'Replies/ajaxSaveSynonymData',  // 添加、修改专属词
  },
  // ↓ 智能学习
  AILearning:{
    gridGet: baseUrl_HXJ + 'Replies/getLearnList',  // 获取智能学习表格数据
    relateGridGet: baseUrl_HXJ + 'Replies/newReplies', // 获取关联问题列表
    relateToReply: baseUrl_HXJ + 'Replies/ajaxLearnSave',  // 关联到问题操作
    ignoreGrid: baseUrl_HXJ + 'Replies/ajaxEditFieldData',  // 忽略
  },
  // ↓ 问答记录
  QARecord:{
    gridGet: baseUrl_HXJ + 'Replies/getInteractionList', //获取问答记录
    gridDel: baseUrl_HXJ + 'Replies/ajaxDelInteractionData', //删除全部问答记录
    exportExcel: baseUrl_HXJ + 'Export/printExcel', //导出问答记录
  }
};

/*---------------- ↓ 设备管理平台 ----------------*/
api.EQPManagement = {
  // ↓ 设备状态
  EQPStatus:{
    statusData: baseUrl_WK + 'mac/Manager/getActionData', // 获取设备的状态数据
    questionFeedBack: baseUrl_HXJ + 'Replies/ajaxSaveFeedbackData',  // 发送反馈问题接口
  },
  // ↓ 素材管理
  MaterialAdmin:{
    gridGet: baseUrl_HXJ + 'Replies/getMediaList',  		// 获取素材表格数据
		gridEdit: baseUrl_HXJ + 'Replies/ajaxSaveMediaData',
		gridDel: baseUrl_HXJ + 'Replies/ajaxDelMediaData',	// 删除素材表格数据
    uploadFile: baseUrl_HXJ + 'Upload/upImage',	// 上传文件
  },
  // ↓ 节目发布
  ProgramReleaseAdmin:{
    gridGet: baseUrl_HXJ + 'Replies/getPublishList',  		// 获取节目表格数据
    gridDel: baseUrl_HXJ + 'Replies/ajaxDelPublishData',  		// 删除节目
		uploadProgram: baseUrl_HXJ + 'Replies/ajaxSavePublishData',  // 新增节目
		toggleRelease: baseUrl_HXJ + 'Replies/ajaxPublishStatus',	// 切换发布状态
		getBanners: baseUrl_HXJ + 'Control/getSlideshowData', // 获取此cid下，是否存在网页版幻灯片
	},
  // ↓ 设备管理
  EQPAdmin:{
    gridGet: baseUrl_WK + 'mac/Manager/getListData',      	// 获取设备数据
    gridAdd: baseUrl_WK + 'mac/Manager/create',           	// 添加设备
    gridEdit: baseUrl_WK + 'mac/Manager/update',          	// 修改设备
    gridDel: baseUrl_WK + 'mac/Manager/delete',           	// 删除设备
    uploadUpgradeFile: baseUrl_WK + 'mac/Manager/upload', 	// 上传设备升级文件
    EQPcontrol: baseUrl_WK + 'mac/Manager/control',       	// 发送设备控制指令
		EQPclear: baseUrl_WK + 'mac/Manager/clearTask',       	// 清空对应设备的未完成任务
		EQPgetSkin: baseUrl_WK + 'mac/Manager/getSkin',       	// 获取主题颜色列表数据
		getCartoons: baseUrl_WK + 'mac/Manager/getCartoonImg',	// 获取主题颜色列表数据
		websocket: process.env.WebSocketAddress									// WebSocket请求地址
	},
	// ↓ 坐标管理
	CoordinateAdmin:{
		gridGet: baseUrl_HXJ + 'Replies/getLocationList',	// 获取坐标数据
		gridEdit: baseUrl_HXJ + 'Replies/ajaxSaveLocationData',
		gridDel: baseUrl_HXJ + 'Replies/ajaxDelLocationData',
	},
	// ↓ 统计分析(图表)
	StatisticsAnalysis:{
		chartGetRunTime: baseUrl_WK + 'mac/Statistic/getRunTime',	// 获取设备运行时间统计信息（小时）
		chartGetClickCount: baseUrl_WK + 'mac/Statistic/getClickCount'	// 获取设备按钮点击统计信息
	},
  // ↓ 用户管理
  UserAdmin:{
    gridGet: baseUrl_HXJ + 'User/getUserList', // 获取用户数据
    gridDel: baseUrl_HXJ + 'User/ajaxDelUserData', // 删除 用户
    gridEdit: baseUrl_HXJ + 'User/ajaxSaveData', // 添加、修改 用户
    // avatarUpload: baseUrl_HXJ + 'User/ajaxSaveData'
  },
  // ↓ 权限中添加用户
  AuthAdmin:{
    // 权限中添加用户到此权限分组中，打开弹窗，得到返回的用户表格数据
    userAuthGet: baseUrl_HXJ + 'User/getUserAuthList',
    userAuthDel: baseUrl_HXJ + 'User/ajaxDelUserAuth',    // 删除此用户的此项权限
    selectUser: baseUrl_HXJ + 'User/ajaxAppendUserAuth'   // 勾选添加此权限的用户
	},
	// ↓ 操作日志
	OperationLog:{
		gridGet: baseUrl_HXJ + 'Admin/getOperationLogList',
		// gridDel: baseUrl_HXJ + '',	// 删除
		deleteAll: baseUrl_HXJ + 'Admin/ajaxDelOperationLogData',	// 删除全部
		exportAll: baseUrl_HXJ + 'Export/printExcel',	// 导出全部
	}
}
/*-------------- ↓ 智能留言管理平台 --------------*/
api.AIMessage = {
  // ↓ 被留言人管理
  GetMsgPersonAdmin:{
    gridGet: baseUrl_WK + 'msg/Person/getListData', // 获取被留言人数据
    gridAdd: baseUrl_WK + 'msg/Person/create',      // 创建被留言人
    gridDel: baseUrl_WK + 'msg/person/delete',      // 删除被留言人
    avatarUpload: baseUrl_WK + 'msg/person/upload', // 头像上传
    gridEdit: baseUrl_WK + 'msg/person/update',     // 修改被留言人

  },
  // ↓ 留言管理
  MessageAdmin:{
    gridGet: baseUrl_WK + 'msg/MsgInfo/getListData', // 获取留言数据
    dialogGet: baseUrl_WK + 'msg/msginfo/getDialogData', // 获取一条留言的对话
    // dialogGet: baseUrl_WK + 'msg/msginfo/getDialogDataAndSet', // 获取一条留言的对话
    // dialogGet: baseUrl_WK + 'msg/msginfo/getDialogDataAndSet', // 获取一条留言的对话
    gridDel: baseUrl_WK + 'msg/MsgInfo/delete',      // 删除留言
    markAsRead: baseUrl_WK + 'msg/msginfo/setReaded',// 标记为已读
    getCaseDetail:baseUrl_WK + "msg/Person/getCase_yjq",//获取留言详情
	},
	// ↓ 留言统计 图表
	MessageStatistics:{
		chartGet: baseUrl_WK + 'msg/Statistic/getStatistic', // 获取留言统计图表数据
	}
}
/*---------------- ↓ 导航管理 ----------------*/
api.PathNav = {
	// ↓ 项目列表 管理
	ProjectListAdmin:{
		treeGet: baseUrl_HXJ + 'Project/getProjectTreeData',
		tableGet: baseUrl_HXJ + 'Project/getLevelsPtsData',
		tableEdit: baseUrl_HXJ + 'Project/ajaxSaveLevelsData',
		// tableDelete: baseUrl_HXJ + 'Project/ajaxDelPoiTypeData',
		// poiTreeGet: baseUrl_HXJ + 'Project/getPoiTypeData',
		// tableEdit: baseUrl_HXJ + 'Project/ajaxSavePoiTypeData',
	},
  // ↓ 文件上传 管理
	FileUploadAdmin:{
		// asideTreeGet: baseUrl_HXJ + 'Navigate/getFileTypeTree',	// 侧边目录树
		asideTreeGet: baseUrl_HXJ + 'Project/getFileTypeTree',	// 侧边目录树
		asideTreeEdit: baseUrl_HXJ + 'Project/ajaxSaveFileTypeData',	// 侧边目录树
		asideTreeDelete: baseUrl_HXJ + 'Project/ajaxDelFileTypeData',	// 侧边目录树
		tableGet: baseUrl_HXJ + 'Project/getFileList',
		tableDelete: baseUrl_HXJ + 'Project/ajaxDelFile',
		dialogGetModelFolder: baseUrl_HXJ + 'Project/ajaxGetModelDir',
		uploadFile: baseUrl_HXJ + 'Project/uploadFile',	// 文件上传
		editFile: baseUrl_HXJ + 'Project/ajaxSaveFileInfo',	// 文件上传
	},
  // ↓ POI类型管理 管理
	POITypeAdmin:{
		tableGet: baseUrl_HXJ + 'Project/getPoiTypeList',
		tableDelete: baseUrl_HXJ + 'Project/ajaxDelPoiTypeData',
		poiTreeGet: baseUrl_HXJ + 'Project/getPoiTypeData',
		tableEdit: baseUrl_HXJ + 'Project/ajaxSavePoiTypeData',
	},
	
};

export default api;



// WEBPACK FOOTER //
// ./src/lib/server.js